import React from "react";
import TrailMarker from "./icons/TrailMarker";

const HOME_DEPOT_MARKER = { shape: "diamond", color: "#b5602f" };

function WorkExperience() {
  const experiences = [
    {
      id: "home-depot-swe",
      title: "Software Engineer",
      company: "Home Depot",
      date: "Jan. 2026 -- Present",
      description:
        "Services Online Platform: Java Spring Microservices, GraphQL, GCP",
      marker: HOME_DEPOT_MARKER,
      url: "https://www.homedepot.com/services/", // TODO: add a link for this entry
    },
    {
      id: "tradeworks",
      title: "Founder",
      company: "TradeWorks Software",
      date: "Feb. 2025 -- Present",
      description:
        "B2B iOS Application: $6k MRR, Serverless architecture, React Native",
      marker: { shape: "circle", color: "#2d4a35" },
      url: "https://apps.apple.com/us/app/holiday-lights-pro/id6751132656", // TODO: add a link for this entry
    },
    {
      id: "home-depot-intern-2",
      title: "Software Engineering Intern",
      company: "Home Depot",
      date: "Summer 2025",
      description: "Services Platform Migration & System Modernization",
      marker: HOME_DEPOT_MARKER,
      url: "https://www.homedepot.com/services/", // TODO: add a link for this entry
    },
    {
      id: "ncsu-research",
      title: "Researcher: Software Development",
      company: "North Carolina State University",
      date: "Aug. 2024 -- Dec. 2024",
      description: "VS Code Extensions, ARM Toolchain, Compilation & Debug",
      marker: { shape: "circle", color: "#a32f2f" },
      url: "https://batistacomputinglab.com/", // TODO: add a link for this entry
    },
    {
      id: "home-depot-intern-1",
      title: "Software Engineering Intern",
      company: "Home Depot",
      date: "Summer 2024",
      description: "Drone Measurement POC",
      marker: HOME_DEPOT_MARKER,
      url: "https://www.homedepot.com/services/", // TODO: add a link for this entry
    },
  ];

  return (
    <section className="build">
      <div className="build-log">
        {experiences.map((exp) => {
          const Tag = exp.url ? "a" : "div";
          const linkProps = exp.url
            ? { href: exp.url, target: "_blank", rel: "noopener noreferrer" }
            : {};

          return (
            <Tag
              key={exp.id}
              className={`build-step${exp.url ? " build-step-link" : ""}`}
              {...linkProps}
            >
              <TrailMarker
                className="build-step-badge"
                shape={exp.marker.shape}
                color={exp.marker.color}
                size={22}
              />
              <div className="build-step-main">
                <div className="build-step-meta-row">
                  <span className="build-step-company">{exp.company}</span>
                </div>
                <div className="build-step-body">
                  <div className="build-step-title-row">
                    <h3>{exp.title}</h3>
                    <span className="build-step-date">{exp.date}</span>
                  </div>
                  <p className="build-step-desc">{exp.description}</p>
                </div>
              </div>
            </Tag>
          );
        })}
      </div>
    </section>
  );
}

export default WorkExperience;
